import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const MobileInProgressWrapperStyled = styled.div`
    text-align: center;
    background: var(--color-surface-secondary);
    h1 {
        font-weight: 800;
    }
`;

export const MobileInProgressImageContentStyled = styled.div`
    padding: 64px 8px;
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 26px 8px;
    }
`;

export const MobileInProgressImageContainerStyled = styled.div`
    img {
        max-width: 100%;
        height: auto;
    }
`;
